export default __webpack_public_path__ + "static/media/Consumer_Wordmark.8ea58a7d.svg";